/**
 * This function converts SelectorCategoryData[] SuggestData
 * @deprecated Use the `ch-combo-box-render` with `suggest = true`
 */
export const convertObjectDataToSuggestData = (selectorCategoriesData) => {
    const suggestData = {
        suggestItems: null,
        suggestLists: []
    };
    if (selectorCategoriesData.length) {
        selectorCategoriesData.forEach(selectorCategory => {
            const suggestList = {
                label: selectorCategory.name,
                items: []
            };
            selectorCategory.items.forEach((objectData) => {
                const suggestItem = {
                    value: objectData.id,
                    description: objectData.description,
                    icon: objectData.icon
                };
                suggestList.items.push(suggestItem);
            });
            suggestData.suggestLists.push(suggestList);
        });
    }
    return suggestData;
};
